import React, { useState } from 'react';

const Endoscopia = () => {
  const [formData, setFormData] = useState({
    descricao: '',
    conclusao: '',
    convenio: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Formulário de Endoscopia submetido:', formData);
  };

  const convenioPadrao = {
    unimed: { formato: 'Padrão Unimed' },
    bradesco: { formato: 'Padrão Bradesco' },
    amil: { formato: 'Padrão Amil' },
  };

  return (
    <div className="bg-white shadow-md rounded-lg p-6">
      <h2 className="text-2xl font-semibold mb-4">Gerar Laudo de Endoscopia</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Descrição do Exame:
          </label>
          <input
            type="text"
            name="descricao"
            value={formData.descricao}
            onChange={handleChange}
            className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-primary focus:border-primary"
            placeholder="Digite a descrição do exame"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">
            Conclusão:
          </label>
          <input
            type="text"
            name="conclusao"
            value={formData.conclusao}
            onChange={handleChange}
            className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-primary focus:border-primary"
            placeholder="Digite a conclusão"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">
            Convênio:
          </label>
          <select
            name="convenio"
            value={formData.convenio}
            onChange={handleChange}
            className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-primary focus:border-primary"
          >
            <option value="">Selecione um convênio</option>
            <option value="unimed">Unimed</option>
            <option value="bradesco">Bradesco Saúde</option>
            <option value="amil">Amil</option>
          </select>
        </div>

        <button
          type="submit"
          className="w-full inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-primary hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
        >
          Gerar Laudo
        </button>
      </form>

      {formData.convenio && (
        <div className="mt-6">
          <p className="text-sm text-gray-700">
            Formato do convênio selecionado:{' '}
            {convenioPadrao[formData.convenio].formato}
          </p>
        </div>
      )}
    </div>
  );
};

export default Endoscopia;
